
// @ts-nocheck
import locale__app_lang_fr_json from "../lang/fr.json";
import locale__app_lang_en_json from "../lang/en.json";


export const localeCodes =  [
  "fr",
  "en"
]

export const localeLoaders = {
  "fr": [{ key: "../lang/fr.json", load: () => Promise.resolve(locale__app_lang_fr_json), cache: true }],
  "en": [{ key: "../lang/en.json", load: () => Promise.resolve(locale__app_lang_en_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "id": "6",
      "code": "fr",
      "dir": "ltr",
      "link": "https://eu-production-translations-module-6lp4usbfna-ew.a.run.app/api/export/aa3dd4ac-61c9-4e58-bcb3-792fbe6176ce/language/55194637-cfbb-4423-8182-f361dd1ec62e/translation?format=json",
      "language": "fr_FR",
      "files": [
        "/app/lang/fr.json"
      ]
    },
    {
      "id": "7",
      "code": "en",
      "dir": "ltr",
      "link": "https://eu-production-translations-module-6lp4usbfna-ew.a.run.app/api/export/aa3dd4ac-61c9-4e58-bcb3-792fbe6176ce/language/d5f9bbe2-4ef4-47bc-b048-22dfb640b407/translation?format=json",
      "language": "en_GB",
      "files": [
        "/app/lang/en.json"
      ]
    }
  ],
  "defaultLocale": "fr",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "lang",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "id": "6",
    "code": "fr",
    "dir": "ltr",
    "link": "https://eu-production-translations-module-6lp4usbfna-ew.a.run.app/api/export/aa3dd4ac-61c9-4e58-bcb3-792fbe6176ce/language/55194637-cfbb-4423-8182-f361dd1ec62e/translation?format=json",
    "language": "fr_FR",
    "files": [
      {
        "path": "/app/lang/fr.json"
      }
    ]
  },
  {
    "id": "7",
    "code": "en",
    "dir": "ltr",
    "link": "https://eu-production-translations-module-6lp4usbfna-ew.a.run.app/api/export/aa3dd4ac-61c9-4e58-bcb3-792fbe6176ce/language/d5f9bbe2-4ef4-47bc-b048-22dfb640b407/translation?format=json",
    "language": "en_GB",
    "files": [
      {
        "path": "/app/lang/en.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
